import type { OutcomeParameterName, OutcomeParameterValue } from '../../../types';
import type { FiltersByOutcomeParameterMap, GlobalFilterOverrides } from '../types';
import { buildGroupKey } from './buildGroupKey';
import { getActiveValueWithOverride } from './getActiveValueWithOverride';
import { getNonNumericFilters } from './getNonNumericFilters';

export const buildNonNumericFiltersGroupKey = (
    filtersMap: FiltersByOutcomeParameterMap,
    globalFilterOverrides: GlobalFilterOverrides,
): string => {
    const pairs: [OutcomeParameterName, OutcomeParameterValue][] = [];

    for (const filter of getNonNumericFilters(filtersMap)) {
        const activeValue = getActiveValueWithOverride(filter, globalFilterOverrides);

        if (!activeValue) {
            continue;
        }

        pairs.push([filter.name, activeValue]);
    }

    return buildGroupKey(pairs);
};
